export default __webpack_public_path__ + "static/media/email icon 001.753c935f.png";